import { UserAccount } from "utils/UserAccount"

export function saveUserDataInLocalStorage(
    userEmail: string,
    userName: string | undefined,
    userPhone: string | undefined
) {
    UserAccount.storeSignIn({
        name: userName,
        email: userEmail,
        phone: userPhone,
    })
}
